import React, {ComponentType} from "react";
import FloorplanHeader from './index';
import {IProps, IContainerProps, IServices, IHandlers, IBaseProps} from './types';

/**
* Gets the interface types as array of strings so we don't need hand code them each time (and reduces chance for mistakes).
*/
import {keys} from 'ts-transformer-keys';
import {hot} from "react-hot-loader";
import ReactUtilsService from "app/services/reactUtils.service";
import store from 'appRoot/Store';
import { Provider } from 'react-redux';

const NS = 'FloorplanHeaderContainer';

const propsKeys: string[] = keys<IProps>();
const basePropsKeys: string[] = keys<IBaseProps>();
const containerPropsKeys: string[] = keys<IContainerProps>();
const handlersKeys: string[] = keys<IHandlers>();
const servicesKeys: string[] = keys<IServices>();

const ThemeWrap = function(all: IContainerProps & IServices) {

  /**
    * Sorts 'all' into IServices, IProps and IContainerProps
    */
  const props: IProps = ReactUtilsService.getObjectByKeys(all, propsKeys) as IProps;
  const containerProps: IContainerProps = ReactUtilsService.getObjectByKeys(all, containerPropsKeys) as IContainerProps;

  /**
   * Passes all base props from container to component
   */
  // @ts-ignore
  basePropsKeys.forEach(key => props[key] = containerProps[key]);

  /**
   * Handlers used to modify app state (via a service) from within the module's container.
   * Similar to redux mapDispatchToProps.
   */
  const handlers: IHandlers = {
    handleDateChangedContainer: (a) => {
    }
  }

  return ReactUtilsService.containerWrap(
    <Provider store={store}>
      <FloorplanHeader {...props} {...handlers} />
    </Provider>
  );
}

/**
 * Returns properties needed for rendering react2angular
 */
export const R2AFloorplanHeader: [ComponentType<unknown>, never[]?, string[]?] = [
  hot(module)(ThemeWrap) as ComponentType<unknown>,
  [...containerPropsKeys] as never[],
  servicesKeys
];
